import moment from "moment";
import React from "react";
import { localize } from "src/l10n";
import { Label } from "src/ui";
import languages from "src/utils/languages";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import "./AcademyCourseMetaDataRow.scss";

interface IProps {
    lessonCount: number;
    userCount?: number;
    language?: number;
    languages?: number[];
    date?: Date;
    isCoursePackage?: boolean;
}

interface IColumnProps {
    icon?: string;
    text: string;
}

const AcademyCourseMetaDataRowColumn = (props: IColumnProps) => {
    return (
        <div>
            {!!props.icon && (
                <Visage2Icon icon={props.icon} size="small" color="grey" />
            )}
            <Label size="body-2" color="grey">{props.text}</Label>
        </div>
    )
}

const AcademyCourseMetaDataRow = (props: IProps) => {
    const languagesArr = props.languages || [props.language];

    // Resolve to known language labels only; unknown/unset (e.g. 0 for SCORM
    // courses, which have no language) are dropped so the column is simply hidden.
    const languageTexts = languagesArr
        .map((language) => languages.find((x) => x.key === (language ?? "").toString())?.text)
        .filter((text): text is string => !!text);

    return (
        <div className="AcademyCourseMetaDataRow">
            {!!props.date && (
                <AcademyCourseMetaDataRowColumn text={localize("SenastUppdaterad") + " " + moment(props.date).format("LL")} />
            )}
            {props.lessonCount > 0 && (
                <AcademyCourseMetaDataRowColumn icon={props.isCoursePackage ? "book" : "book-1"} text={props.lessonCount.toString()} />
            )}
            {props.userCount > 0 && (
                <AcademyCourseMetaDataRowColumn icon="profile-2user" text={props.userCount.toString()} />
            )}
            {
                languageTexts.length > 0 && (
                    <AcademyCourseMetaDataRowColumn
                        icon="global"
                        text={languageTexts.join(", ")}
                    />
                )
            }
        </div>
    )
}

export default AcademyCourseMetaDataRow;
